export function capitalizeLicense() {
    return function (name) {
        name = name.toLowerCase();

        if (name === 'epub') {
            return 'ePub';
        }

        return name.charAt(0).toUpperCase() + name.slice(1);
    };
}
